import * as React from "react";

import { useSchematicBuilderContext } from "../../SchematicBuilderContext";
import { preventDrag } from "../../util/preventDrag";

const PACKAGE_PLACEHOLDER = "package.suffix";
const NAME_PLACEHOLDER = "ClassName";

export function PackageNameInput() {
  const { useSchematic, setSchematic, parentPackage } =
    useSchematicBuilderContext();
  const pkgRef = React.useRef<HTMLInputElement | null>(null);
  const packageSuffix = useSchematic((schematic) => schematic.packageSuffix);
  const name = useSchematic((schematic) => schematic.name);

  return (
    <div className="builder-package-name">
      {parentPackage && (
        <span className="builder-package-prefix">{parentPackage}.</span>
      )}
      <input
        className="builder-input builder-package"
        placeholder={PACKAGE_PLACEHOLDER}
        value={packageSuffix ?? ""}
        onChange={(evt) => setSchematic({ packageSuffix: evt.target.value })}
        pattern="(([a-z_][a-z0-9_]*)(\.([a-z_][a-z0-9_]*))*)?"
        style={{ width: `${(packageSuffix || PACKAGE_PLACEHOLDER).length}ch` }}
        {...preventDrag}
        ref={pkgRef}
      />
      <button
        type="button"
        className="builder-icon-button builder-edit-package"
        onClick={() => {
          const pkgInput = pkgRef.current!;
          pkgInput.style.display = "initial";
          pkgInput.focus();
          pkgInput.style.display = "";
        }}
      >
        🖉
      </button>
      <span className="builder-operator">.</span>
      <input
        className="builder-input builder-name"
        placeholder={NAME_PLACEHOLDER}
        value={name ?? ""}
        onChange={(evt) => setSchematic({ name: evt.target.value })}
        required
        pattern="[a-zA-Z_][a-zA-Z0-9_]*"
        style={{ width: `${(name || NAME_PLACEHOLDER).length}ch` }}
        {...preventDrag}
      />
    </div>
  );
}
